<template lang="pug">
  .root
    Base(:liveType="liveType")

</template>

<style src="./Event.scss" lang="scss" scoped>

</style>

<script>
import Base from './components/Base'
import {LIVE_TYPE} from './helper/def'

export default {
  name: "TopLiveEvent",
  components: {
    Base
  },
  data() {
    return {
      liveType: LIVE_TYPE.EVENT
    }
  },
  props: {},
  computed: {},
  watch: {},
  mounted() {},
  async created() {},
  updated() {},
  async destroyed() {},
  methods: {}
};
</script>
